import axios from "axios";
import {getBackendURL, httpResponse, httpResponseError} from "./fn";

/**
 * @typedef UserOptions
 * @type {Object}
 * @property {boolean} onlyMyDeal
 * @property {boolean} openLinkCurrentTab
 * @property {string} .theme - Тема оформления ("default" или другая)
 * @property {string} .timezone - Часовой пояс пользователя (например "Europe/Moscow")
 * @property {number} .dealsListLimit - Лимит сделок в списке
 */

/**
 * @type {UserOptions}
 * @property {boolean} onlyMyDeal
 */
export let userOptions = {}

/**
 * Загружает настройки пользователя с бэкенда
 * @async
 * @function loadUserOptions
 * @returns {Promise<Object>} Объект с настройками пользователя
 * @returns {boolean} .openLinkCurrentTab - Открывать ссылки в текущей вкладке
 * @returns {boolean} .onlyMyDeal - Показывать только мои сделки
 * @returns {string} .theme - Тема оформления ("default" или другая)
 * @returns {string} .timezone - Часовой пояс пользователя (например "Europe/Moscow")
 * @returns {number} .dealsListLimit - Лимит сделок в списке
 */
export const loadUserOptions = async() => {
  const backendUrl = getBackendURL();

  if(Object.values(userOptions).length)
    return userOptions;

  const result = await new Promise((resolve) => {
    axios.get(`${backendUrl}/user/option/get`, {
      withCredentials: true,
      headers: {
        'content-type': 'application/json',
      },
    }).then((response) => {
      userOptions = response.data
      resolve(response.data)
    }).catch((error) => {
      resolve(null)
    });
  })

  return result;
}


/**
 * Установить пользователькую настройку
 */
export const setUserOption = async (option, value) => {
  userOptions[option] = value;

  const result = await new Promise((resolve) => {
    axios.post(`${getBackendURL()}/user/option/set/`, {option, value}, {
      withCredentials: true,
      headers: {
        'content-type': 'application/json',
      },
    }).then((response) => {
      resolve(httpResponse(response.data))
    }).catch((error) => {
      resolve(httpResponseError(error));
    });
  })

  return result;
}